import script from "./RecaptchaTokenScript.vue?vue&type=script&lang=js"
export * from "./RecaptchaTokenScript.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__